import { EIPTable } from './Table'

export default EIPTable
